import gqlClient from "../../dependencies/gqlClient";
import DEFAULT_RESTAURANT_STATUSES from "../../model/restaurantStatuses/default";
import AllRestaurantIdsQuery, {
  type QueryVariables,
} from "../queries/allRestaurantIds";

export type GetAllRestaurantIdsParams = {
  variables: QueryVariables;
  abortSignal?: AbortSignal;
};

export type MapRestaurantPreview = {
  id: number;
  menuTitle: string | null;
  lat: number | null;
  lng: number | null;
  rating: number | null;
  regionRanking: number | null;
};

export default async function getAllRestaurantIds(
  variables: GetAllRestaurantIdsParams["variables"],
  abortSignal: GetAllRestaurantIdsParams["abortSignal"],
): Promise<MapRestaurantPreview[]> {
  // sort the input variables to more reliably make use of the API caching (copy arrays as to not mutate the the function arguments)
  const sortedTags = [...(variables.tags || [])];
  sortedTags.sort();

  const sortedSuburbs = [...(variables.suburbs || [])];
  sortedSuburbs.sort();

  const sortedStatus = [...(variables.status || DEFAULT_RESTAURANT_STATUSES)];
  sortedStatus.sort();

  const { allRestaurants } = await gqlClient({
    query: AllRestaurantIdsQuery,
    variables: {
      ...variables,
      tags: sortedTags,
      suburbs: sortedSuburbs,
      status: sortedStatus,
    },
    abortSignal,
  });

  return (allRestaurants ?? []).flatMap((restaurant) => {
    if (restaurant?.id == null) {
      return [];
    }

    return [
      {
        ...restaurant,
        id: restaurant.id,
        lat: restaurant.lat == null ? null : Number(restaurant.lat),
        lng: restaurant.lng == null ? null : Number(restaurant.lng),
      },
    ];
  });
}

export type AllRestaurantIds = Awaited<ReturnType<typeof getAllRestaurantIds>>;
